import { useAtom } from "jotai";
import { useCallback } from "react";

import { pagesAtom } from "../../fkc.state";
import { Pages } from "../../fkc.types";
import { Fallback } from "../shared/fallback/fallback.component";

export function RegistrationRetryPage(): JSX.Element {
  const [, setPage] = useAtom(pagesAtom);

  const goToRegistrationPage = useCallback(() => {
    setPage(Pages.REGISTRATION);
  }, [setPage]);

  return (
    <Fallback
      title="Something went wrong while creating your account. Try again?"
      onTryAgain={goToRegistrationPage}
    />
  )
}
